import { render, staticRenderFns } from "./sidemenu_youtube.vue?vue&type=template&id=46d276a4&scoped=true&"
import script from "./sidemenu_youtube.vue?vue&type=script&lang=js&"
export * from "./sidemenu_youtube.vue?vue&type=script&lang=js&"
import style0 from "./sidemenu_youtube.vue?vue&type=style&index=0&id=46d276a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d276a4",
  null
  
)

export default component.exports